import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import React, { useEffect, useState } from 'react';

import Button from './buttons/Button';

const CookieConsent: React.FC = () => {
  const { t } = useTranslation('cookie');
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consentGiven = localStorage.getItem('cookieConsent');
    if (consentGiven === null) {
      setShowConsent(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setShowConsent(false);
  };

  const handleRejectAll = () => {
    localStorage.setItem('cookieConsent', 'none');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className='fixed bottom-0 right-0 z-50 m-4 max-w-md rounded-lg bg-gray-100 bg-opacity-90 p-6 shadow-md dark:bg-slate-700'>
      <div className='container mx-auto'>
        <h2 className='mb-2 text-lg font-bold dark:text-slate-200'>
          {t('title')}
        </h2>
        <p className='mb-4 text-sm text-gray-700 dark:text-slate-400'>
          {t('description')}
        </p>
        <div className='flex flex-wrap justify-start gap-2'>
          <Button onClick={handleAcceptAll}>{t('acceptAll')}</Button>
          <Button onClick={handleRejectAll} variant='outline'>
            {t('rejectAll')}
          </Button>
        </div>
        <div className='mt-4'>
          <Link
            href='/privacy-policy'
            className='self-center text-sm text-primary-500 hover:underline'
          >
            {t('privacyPolicy')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
